import { useQuery } from '@tanstack/react-query'
import { moderationApi } from '../../services/api'

// moderationStatusQueryKey caches one brand's moderation state. Command
// Center invalidates the ['moderation-status'] prefix when it changes a
// brand's switch or flagged-content choice.
export const moderationStatusQueryKey = (orgSlug) => ['moderation-status', orgSlug]

// useModerationStatus reads whether moderation applies to the brand now:
// { platform_mode, org_enabled, enforcing, flagged_content }.
export function useModerationStatus(orgSlug) {
  return useQuery({
    queryKey: moderationStatusQueryKey(orgSlug),
    queryFn: () => moderationApi.getModerationStatus(orgSlug),
    enabled: Boolean(orgSlug),
    staleTime: 30_000,
    retry: false,
  })
}
